import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { User } from "@/models/responses";
import { AuthContext } from "@/hooks/authContext";

const DEMO_OWNER_ID = 3;

const demoUser: User = {
    id: -1,
    givenName: "Demo",
    lastName: "User",
    email: "demo@keroshospitality.com",
    profileImageUri: "",
    isAdmin: false,
    visibleOwners: [DEMO_OWNER_ID],
};

export const DemoAuthProvider = ({ children }: { children: React.ReactNode }) => {
    const navigate = useNavigate();

    const value = useMemo(
        () => ({
            user: demoUser,
            login: () => {},
            logout: () => navigate("/demo"),
        }),
        [navigate],
    );

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
